import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, ViewChild, inject } from '@angular/core'

import { Store } from '@ngrx/store'
import { TooltipModule } from 'primeng/tooltip'

import { FlxIconModule } from '@flowx/angular-ui-toolkit'
import { BpmnActionsStore } from '@flowx/designer/modules/bpmn-editor/components/bpmn-editor-node-actions/store/bpmn-editor-actions.store'
import { FlxClickStopPropagationDirective } from '@flowx/designer/modules/core/directives/stop-propagation.directive'

import { BPMNNodeActionsEffectsService } from './store/bpmn-node-actions.effects'

@Component({
  selector: 'app-bpmn-editor-node-actions',
  imports: [CommonModule, FlxClickStopPropagationDirective, TooltipModule, FlxIconModule],
  templateUrl: './bpmn-editor-node-actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bpmn-editor-node-actions.component.scss'],
})
export class BpmnEditorNodeActionsComponent {
  @Input() actions: BpmnActionsStore
  @ViewChild('nodeActions') nodeActionsRef
  @Input() maxWidth?: number
  @Input() readonly?: boolean = false

  readonly store = inject(Store)
  readonly storeEffectsService = inject(BPMNNodeActionsEffectsService)

  get nodeActionsPanelEl(): HTMLElement {
    return this.nodeActionsRef.nativeElement
  }
}
